<template>
    <div class="error-warp">
        <div class="error-footer">
            <div class="error-footer__circle">
                <div class="circle1">
                    <div class="circle2">
                        <div class="circle3">
                            <div class="circle4"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="error-footer__sea">
                <h1>产品暂时接收不到信号</h1>
                <p>您可返回首页后，查看别的产品</p>
                <a @click="$router.push({ path: '/' })">返回首页</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    };
</script>

<style lang="less" scoped>
    .error-warp {
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        min-height: 700px;
        min-width: 1280px;
        background: url("./img_bg.png");
        background-repeat: repeat-x;
        .error-footer {
            height: 50%;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            .error-footer__sea {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 2;
                background: url("./img_sea.png");
                background-position: center top;
                color: #ffffff;
                text-align: center;
                a {
                    color: #ffffff;
                    padding: 10px 24px;
                    background-image: linear-gradient(
                        0deg,
                        #44faff 0%,
                        #02d6dc 100%
                    );
                    box-shadow: 0px 6px 35px 0px rgba(101, 77, 222, 0.4);
                    border-radius: 38px;
                    margin: 0 auto;
                    cursor: pointer;
                }
                h1 {
                    margin-top: 180px;
                    font-size: 60px;
                    font-weight: 500;
                }
                p {
                    line-height: 80px;
                    font-size: 20px;
                }
            }
            .error-footer__circle {
                width: 840px;
                height: 840px;
                position: absolute;
                left: 50%;
                top: -452px;
                transform: translateX(-50%);
                border-radius: 50%;
                z-index: 1;
                border: 1px solid transparent;
                background-color: rgba(70, 192, 255, 0.2);
                background-image: url("./img_ship.png");
                background-repeat: no-repeat;
                background-position: 143px 242px;
                div {
                    margin: 0 auto;
                    border-radius: 50%;
                    background: rgba(70, 192, 255, 0.1);
                    border: 1px solid transparent;
                    margin-top: 50%;
                    transform: translateY(-50%);
                }
                .circle1 {
                    width: 626px;
                    height: 626px;
                }
                .circle2 {
                    width: 451px;
                    height: 451px;
                }
                .circle3 {
                    width: 284px;
                    height: 284px;
                }
                .circle4 {
                    width: 134px;
                    height: 134px;
                }
            }
        }
    }
</style>
